import {
    Component,
    HostListener,
    Inject,
    Input,
    OnInit,
    ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TextUtils } from "../../../../util/TextUtils";
import { CookieService } from "ngx-cookie-service";
import { StorageService } from "app/main/module/common/service/storage.service";
import * as moment from "moment";
import {
    APP_DATE_FORMATS,
    AppDateAdapter,
} from "../../report/format-datepicker";
import {
    DateAdapter,
    ErrorStateMatcher,
    MAT_DATE_FORMATS,
} from "@angular/material/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Globals } from "../../../common/global";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Case } from "../case";
import { CasesService } from "../cases.service";
import { fromEvent, of, Subscription } from "rxjs";
import {
    catchError,
    debounceTime,
    distinctUntilChanged,
    switchMap,
} from "rxjs/operators";
import { AssignService } from "../../cassette/assign/assign.service";
import { TimestampService } from "app/main/module/common/timeConstant.service";
import { start } from "repl";
import { ReminderRefreshService } from "../reminderRefresh.service";

const timeZone = require("moment-timezone");
@Component({
    selector: "add-case-dialog",
    templateUrl: "add-case-dialog.component.html",
    styleUrls: ["add-case-dialog.component.scss"],
    providers: [
        { provide: DateAdapter, useClass: AppDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    ],
})
export class AddCaseDialogComponent implements OnInit {
    [x: string]: any;
    patientForm: FormGroup;
    platform = "web";
    @Input()
    min: "D" | null;
    today = new Date();
    isEnterPressed = false;
    hasFirstDataShown: Boolean;
    dobStamp = 0;
    dobString = "";
    deleted: boolean;
    rowId: any;
    memberInfo: any;
    errorMessage: any;
    @ViewChild("input", { static: true }) input: any;
    @ViewChild("filter", { static: true }) filter: any;
    searchInputSubscription: Subscription;
    message: any;
    inputValue: string;
    filteredPatients: Array<any> = [];
    HASH = "#";
    showNoResultsMessage = false;
    isLoading = false;
    patientlist: Array<any> = [];
    name: string;
    selectLab: string;
    labs = [];
    labTimeZone: string;
    currentDate: Date;
    uniqueTimestamp: any;
    startAt: any;

    constructor(
        public dialogRef: MatDialogRef<AddCaseDialogComponent>,
        private _formBuilder: FormBuilder,
        public snackBar: MatSnackBar,
        private userService: StorageService,
        private cookieService: CookieService,
        private global: Globals,
        private router: Router,
        private httpClient: HttpClient,
        @Inject(MAT_DIALOG_DATA) public data: Case,
        public translate: TranslateService,
        public caseService: CasesService,
        public paginationService: AssignService,
        public timeStampService: TimestampService,
        public reminderRefreshService: ReminderRefreshService
    ) {
        this.currentDate = new Date();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    /**
     * On init
     */
    ngOnInit(): void {
        // Validators.pattern(/^\S*$/)
        this.labs = JSON.parse(localStorage.getItem("lab_cases_list"));
        this.patientForm = this._formBuilder.group({
            // Validators.pattern(/^\S+/)
            patientId: [
                "",
                [
                    Validators.required,
                    Validators.pattern(/^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/),
                ],
            ],
            title: ["", [Validators.required, Validators.pattern(/^[^\s].*$/)]],
            selectLab: [
                "",
                [Validators.required, Validators.pattern(/^[A-Za-z0-9 ]/)],
            ],
            patientName: [
                "",
                [
                    Validators.required,
                    Validators.pattern(/^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/),
                ],
            ],
            description: ["", [this.wordCountValidator(50)]],
            requestedOn: [new Date(), Validators.required],
            probableReceiveDate: ["", Validators.required],
            receivedOn: [{ value: "", disabled: true }],
            paitentBookedOn: [{ value: "", disabled: true }],
        });

        this.searchPharmacyPatient();

        this.name = this.userService.getCookie("name");
        this.labTimeZone = localStorage.getItem("defaultTz");

        this.timeStampService.timestamp$.subscribe((ts) => {
            this.uniqueTimestamp = ts;
        });

        setTimeout(() => {
            const inputElement = document.getElementById("id");
            if (inputElement) {
                inputElement.focus();
            }
        }, 0);
    }

    goBack() {
        this.router.navigate(["/patient"]).then(() => {
            // this.ngOnDestroy();
            this.ngOnInit();
            // window.location.reload();
        });
    }
    toUpperCaseString(str) {
        return str.trim().toUpperCase();
    }

    openSnackBar(message: string, action: string): void {
        this.snackBar.open(message, action, {
            duration: 10000,
        });
    }

    private handleError(error: Error): void {
        this.hasFirstDataShown = false;
        this.openSnackBar(error.message, this.translateSentence("Common.ok"));
        // this.notify.update(error.message, 'error');
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }

    toLabMidnightTimestamp(date: Date | string, labTimezone: string): number {
        const dateString = moment(date).format("YYYY-MM-DD");
        return moment.tz(dateString, "YYYY-MM-DD", labTimezone).valueOf();
    }

    addCase() {
        if (this.hasFirstDataShown) return;
        this.hasFirstDataShown = true;
        let patientId = this.patientForm.value.patientId;
        let caseTitle = this.patientForm.value.title;
        let patientName = this.patientForm.value.patientName;
        let description = this.patientForm.value.description;
        let requestedOn = this.patientForm.value.requestedOn;
        let probableReceiveDate = this.patientForm.value.probableReceiveDate;
        let receivedOn = this.patientForm.value.receivedOn;
        let patientBookedOn = this.patientForm.value.paitentBookedOn;
        let labId = this.patientForm.value.selectLab;

        const requestedTs = requestedOn
            ? this.toLabMidnightTimestamp(requestedOn, this.labTimeZone)
            : null;

        let probableReceivedTs = probableReceiveDate
            ? this.toLabMidnightTimestamp(probableReceiveDate, this.labTimeZone)
            : null;

        // console.log(this.patientForm.value);

        if (
            !probableReceivedTs ||
            (requestedTs && probableReceivedTs <= requestedTs)
        ) {
            probableReceivedTs = requestedTs
                ? moment.utc(requestedTs).add(1, "minute").valueOf()
                : moment.utc().add(1, "minute").valueOf();
        }
        let caseData: Case = {
            patient_id: patientId,
            title: caseTitle.trim(),
            description: description,
            patient_name: patientName,
            lab_id: labId,
            requested_on: String(requestedTs) || "",
            probable_received_date: String(probableReceivedTs) || "",
            received_on: receivedOn
                ? moment
                      .tz(receivedOn, this.labTimeZone)
                      .utc()
                      .valueOf()
                      .toString()
                : "",
            patient_booked_on: patientBookedOn
                ? moment
                      .tz(patientBookedOn, this.labTimeZone)
                      .utc()
                      .valueOf()
                      .toString()
                : "",

            status: "assigned",
            created: this.uniqueTimestamp
                ? moment(this.uniqueTimestamp).utc().valueOf().toString()
                : moment.utc().valueOf().toString(),
            created_by: this.name,
            updated_timestamp: this.uniqueTimestamp
                ? moment(this.uniqueTimestamp).utc().valueOf().toString()
                : moment.utc().valueOf().toString(),
        };

        this.caseService.postCase(caseData).subscribe(
            (response: any) => {
                // console.log("Response from add case:", response);
                if (response && response.status === "success") {
                    this.openSnackBar(
                        this.translateSentence(
                            "LabCases.CaseAddedSuccessfully"
                        ),
                        this.translateSentence("Common.ok")
                    );
                    this.hasFirstDataShown = false;
                    this.patientForm.reset();
                    this.dialogRef.close();
                    this.reminderRefreshService.triggerRefresh();
                } else {
                    this.openSnackBar(
                        this.translateSentence("LabCases.CaseAddFailed"),
                        this.translateSentence("Common.ok")
                    );
                    this.hasFirstDataShown = false;
                }
            },
            (error) => {
                console.log("Inside error block:", error);
                this.hasFirstDataShown = false;
                this.handleError(error);
            }
        );
    }

    searchPharmacyPatient() {
        this.searchInputSubscription = fromEvent(
            this.filter.nativeElement,
            "input"
        )
            .pipe(
                debounceTime(150),
                distinctUntilChanged(),
                switchMap((event: any) => {
                    this.inputValue = event.target.value.trim();
                    // console.log("Input value:", this.inputValue);
                    const enteredValue = event.target.value.trim();
                    // console.log("Entered value:", enteredValue);

                    const sanitizedValue = enteredValue.replace(
                        /[^a-zA-Z0-9 ]/g,
                        ""
                    );
                    if (!sanitizedValue) {
                        this.filteredPatients = [];
                        this.showNoResultsMessage = false;
                        this.isLoading = false;
                        return of([]);
                    }
                    this.isLoading = true;
                    return this.paginationService
                        .searchPatient(sanitizedValue)
                        .pipe(
                            catchError((err) => {
                                console.error("Search error:", err);
                                this.isLoading = false;
                                this.showNoResultsMessage = true;
                                return of([]);
                            })
                        );
                })
            )
            .subscribe((response: any) => {
                this.filteredPatients = [];
                const data = response?.data;
                if (data) {
                    this.isLoading = false;
                    this.patientlist = data;
                    this.patientlist.forEach((el) => {
                        this.filteredPatients.push({
                            patient_id: el.patient_id,
                            first_name: el.first_name,
                            last_name: el.last_name,
                        });
                    });
                }
                if (
                    this.filter.nativeElement.value.length >= 1 &&
                    this.filteredPatients.length === 0
                ) {
                    this.showNoResultsMessage = true;
                } else {
                    this.showNoResultsMessage = false;
                }
            });
    }

    onKeyDownSearch(event: KeyboardEvent): void {
        const inputElement = event.target as HTMLInputElement;
        const sanitizedValue = inputElement.value.replace(/[^a-zA-Z0-9 ]/g, "");
        inputElement.value = sanitizedValue;
        // this.searchText = sanitizedValue;
    }

    clearInputSearchPatient() {
        this.inputValue = "";
        this.patientForm.get("patientId")?.setValue("");
        this.patientForm.get("patientName")?.setValue("");
        this.filteredPatients = [];
    }

    onPatientSelected(patient: any): void {
        this.patientForm.patchValue({
            patientId: patient.patient_id,
            patientName: (patient.first_name + " " + patient.last_name).trim(),
        });
    }

    refreshSearch(event) {
        if (event.code === "Backspace" && this.inputValue.length === 1) {
            this.patientForm.get("patientName")?.setValue("");
            // console.log("Input cleared, patient name reset.");
        }
    }

    fromDateValueChange(event: any) {
        this.startAt = event;
    }

    wordCountValidator(maxWords: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) return null;
            const trimmed = control.value.trim();

            if (trimmed.length === 0) {
                return { whitespaceOnly: true };
            }

            const wordCount = trimmed.trim().split(/\s+/).length;
            return wordCount > maxWords
                ? { wordLimit: { maxWords, actual: wordCount } }
                : null;
        };
    }
}
